const ACTIONS = {
	SERVICE_CURRENT_REQUEST_SUCCESS: 'SERVICE_CURRENT_REQUEST_SUCCESS',
	SERVICE_REQUEST_FAILURE: 'SERVICE_REQUEST_FAILURE',
	SET_SERVICE_NEED_REFRESH: 'SET_SERVICE_NEED_REFRESH',
};

const initialState = {
	currentData: {},
	isNeedRefresh: false,
};

export default (state = initialState, action) => {
	switch (action.type) {
	
	case ACTIONS.SERVICE_CURRENT_REQUEST_SUCCESS: {
		return { ...state, currentData: action.result };
	}

	case ACTIONS.SET_SERVICE_NEED_REFRESH: {
		return { ...state, isNeedRefresh: action.isNeedRefresh };
	}
	
	case ACTIONS.SERVICE_REQUEST_FAILURE: {
		return { ...state };
	}
	
	default: {
		return state;
	}
	}
};

export const setCurrentData = result => ({
	type: ACTIONS.SERVICE_CURRENT_REQUEST_SUCCESS,
	result
});

export const setServiceNeedRefresh = isNeedRefresh => ({
	type: ACTIONS.SET_SERVICE_NEED_REFRESH,
	isNeedRefresh
});

export const hasError = (error) => ({
	type: ACTIONS.SERVICE_REQUEST_FAILURE,
	error,
});


